import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/form'
import EntityFieldDisplayGroup from '../shared/EntityFieldDisplayGroup'
import PageLayout from '../shared/PageLayout'
import { KindViewPageProps } from '../KindPages'
import LearningUnitEditorWrapper from '../../../../ui/microfrontend/LearningUnitEditorWrapper'
import useHasPermission from '../../../permission/useHasPermission'
import linkKeyFromString = com.eidu.sharedlib.entity.link.linkKeyFromString
import EntityAction = com.eidu.sharedlib.entity.permission.EntityAction

const LearningUnitViewPage = ({ entity, entityType, fields }: KindViewPageProps) => {
  const navigate = useNavigate()

  const { hasPermission: hasUpdatePermission } = useHasPermission(entity.entity.id, EntityAction.UpdateEntity)

  const navigateToEdit = () => {
    navigate(`/entities/${entityType.id.toString()}/edit/${entity.entity.id.toString()}`)
  }

  return (
    <PageLayout
      title={entity.primaryLabelText}
      subtitle={entityType.name}
      actions={
        hasUpdatePermission ? (
          <Button onClick={navigateToEdit} data-testid="entity-action-edit">
            Edit
          </Button>
        ) : undefined
      }
      showBack
    >
      <EntityFieldDisplayGroup entityType={entityType} fields={fields} />
      <LearningUnitEditorWrapper
        entityId={entity.entity.id.toString()}
        entityLinks={[...(entity.entity.links.asJsReadonlyMapView().entries() || [])].map(([key, value]) => ({
          key,
          value,
        }))}
        linkKeyFromString={linkKeyFromString}
        onRegisterPartialSubmit={() => Promise.resolve([])}
        mode="view"
      />
    </PageLayout>
  )
}

export default LearningUnitViewPage
